// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "root-25sr_";
var _5 = "read-3RV1T";
var _6 = "header-3Ipr3";
var _7 = "title-3od2G";
var _8 = "statuses-3C7Bn";
var _9 = "wrap__statuses-MY3oY";
var _a = "block-2ILAQ";
var _b = "description-2aEqA";
var _c = "footer-NqYhW";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "root", _5 as "read", _6 as "header", _7 as "title", _8 as "statuses", _9 as "wrap__statuses", _a as "block", _b as "description", _c as "footer" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "root": _4, "read": _5, "header": _6, "title": _7, "statuses": _8, "wrap__statuses": _9, "block": _a, "description": _b, "footer": _c }
